import type * as React from 'react';

import * as Progress from '@radix-ui/react-progress';

function ProgressRoot({ children, value }: { children: React.ReactNode; value: number }) {
    return (
        <Progress.Root
            className="relative h-2 w-full overflow-hidden rounded-full bg-primary/20"
            value={value}
        >
            {children}
        </Progress.Root>
    );
}

function ProgressIndicator({ value }: { value: number }) {
    return (
        <Progress.Indicator
            className="h-full bg-primary transition-all"
            style={{ transform: `translateX(-${100 - value}%)` }}
        />
    );
}

export { ProgressIndicator, ProgressRoot };
